__turbopack_context__.v({
  "imageContainer": "entityCategoryImage-module-scss-module__9mV4Sa__imageContainer",
  "imageContainerSingle": "entityCategoryImage-module-scss-module__9mV4Sa__imageContainerSingle",
  "imageContainerStack": "entityCategoryImage-module-scss-module__9mV4Sa__imageContainerStack",
  "imageContainerStackSingle": "entityCategoryImage-module-scss-module__9mV4Sa__imageContainerStackSingle",
  "imageDropdown": "entityCategoryImage-module-scss-module__9mV4Sa__imageDropdown",
  "imageLength": "entityCategoryImage-module-scss-module__9mV4Sa__imageLength",
  "imageSmall": "entityCategoryImage-module-scss-module__9mV4Sa__imageSmall",
  "imageWrapper": "entityCategoryImage-module-scss-module__9mV4Sa__imageWrapper",
  "itemBackground": "entityCategoryImage-module-scss-module__9mV4Sa__itemBackground",
  "itemContainer": "entityCategoryImage-module-scss-module__9mV4Sa__itemContainer",
});
